module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_rc-switch@1.6.0@rc-switch/es/index.js
// module id = 701
// module chunks = 0